import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f56edb4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-8 flex items-start justify-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-700 text-3xl font-semibold mb-1" }, "Lingo Data")
], -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "[&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5"
}
const _hoisted_6 = { class: "mb-6 border-b border-gray-200" }
const _hoisted_7 = { class: "-mb-px flex items-center gap-6" }
const _hoisted_8 = { class: "mb-6 flex flex-wrap items-center gap-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold text-gray-700" }, "From", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "to", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "mb-6 flex flex-wrap items-center gap-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "grade-filter",
  class: "text-gray-800 text-sm font-semibold"
}, " Class(es) / Grade(s) ", -1))
const _hoisted_15 = { class: "min-w-[18rem]" }
const _hoisted_16 = { class: "ml-auto" }
const _hoisted_17 = {
  key: 0,
  class: "bg-white rounded-lg border border-gray-300 p-12 text-center"
}
const _hoisted_18 = { class: "flex flex-col items-center justify-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-gray-500" }, "Loading students...", -1))
const _hoisted_20 = {
  key: 1,
  class: "bg-white rounded-lg border border-gray-300 overflow-hidden"
}
const _hoisted_21 = { class: "overflow-x-auto" }
const _hoisted_22 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_23 = { class: "bg-gray-50" }
const _hoisted_24 = { class: "flex items-center gap-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status", -1))
const _hoisted_26 = { class: "flex items-center gap-1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Student", -1))
const _hoisted_28 = { class: "flex items-center gap-1" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Classwork", -1))
const _hoisted_30 = { class: "flex items-center gap-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Homework", -1))
const _hoisted_32 = { class: "flex items-center gap-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Working on", -1))
const _hoisted_34 = { class: "flex items-center gap-1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Interventions", -1))
const _hoisted_36 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_37 = { class: "lingo-td lingo-td--status whitespace-nowrap" }
const _hoisted_38 = { class: "lingo-td whitespace-nowrap" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "lingo-td whitespace-nowrap text-sm text-gray-700" }
const _hoisted_41 = { class: "lingo-td whitespace-nowrap text-sm text-gray-700" }
const _hoisted_42 = { class: "lingo-td whitespace-nowrap text-sm text-gray-700" }
const _hoisted_43 = { class: "lingo-td whitespace-nowrap" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  colspan: "6",
  class: "px-6 py-10 text-center text-sm text-gray-500"
}
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-gray-900 mb-1" }, "No Students found", -1))
const _hoisted_49 = {
  key: 2,
  class: "mt-6 flex items-center justify-between text-sm text-gray-500"
}

import { computed, defineComponent, h, onMounted, onUnmounted, ref, watch } from "vue";
import moment from "moment";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLingoStore } from "@/stores/lingoStore";

import { useRoute, useRouter } from "vue-router";
import { useSubjectStore } from "@/stores/subjectStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { Learner } from "@/interfaces/learner.interface";
import { QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";
import { UserIcon } from "@heroicons/vue/24/outline";

import StatusBadge from "@/modules/main/components/manage/StatusBadgeComponent.vue";
import StatusDetailModal from "@/modules/main/components/manage/StatusDetailModal.vue";
import InterventionsModal from "@/modules/main/components/manage/InterventionsModal.vue";
import LingoBadge from "@/modules/main/components/manage/LingoBadgeComponent.vue";
import { DatePicker } from "v-calendar";
import "v-calendar/style.css";
import { KnowledgeComponent, StudentLingoData } from "@/interfaces/lingo.interfaces";
import { getWorkingOn } from "@/modules/main/utils/lingoActivity";


// Inline SortIcon component for column headers
import * as XLSX from "xlsx";
import { showToast } from "@/utils/toastUtils";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";

const BATCH_SIZE = 50
type StudentDisplay = Learner & {
  displayName: string
  mathClasses: string[]
  englishClasses: string[]
  classwork: string
  classworkSeconds: number
  homework: string
  homeworkSeconds: number
  workingOn: string
  interventions: number
  interventionKCs: KnowledgeComponent[]
}

const REFRESH_INTERVAL_MS = 30 * 1000; // 30 seconds (learner data)
const ENGAGEMENT_REFRESH_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes (engagement data from BigQuery)

export default /*#__PURE__*/_defineComponent({
  __name: 'LingoDataView',
  setup(__props) {


const SortIcon = defineComponent({
  name: 'SortIcon',
  props: {
    active: { type: Boolean, default: false },
    dir: { type: String, default: 'asc' },
  },
  setup(props) {
    return () => {
      if (props.active) {
        // Active arrow (points up for asc, down for desc)
        return h('svg', {
          width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg',
          class: 'inline-block',
          style: { transform: props.dir === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.12s' }
        }, [
          h('path', {
            d: 'M7.99998 3.33331V12.6666M7.99998 12.6666L12.6666 7.99998M7.99998 12.6666L3.33331 7.99998',
            stroke: '#475467', 'stroke-width': '1.33', 'stroke-linecap': 'round', 'stroke-linejoin': 'round'
          })
        ])
      }
      // Inactive chevron up/down
      return h('svg', {
        width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'inline-block opacity-60'
      }, [
        h('path', {
          d: 'M4.66675 9.99996L8.00008 13.3333L11.3334 9.99996M4.66675 5.99996L8.00008 2.66663L11.3334 5.99996',
          stroke: '#667085', 'stroke-width': '1.33', 'stroke-linecap': 'round', 'stroke-linejoin': 'round'
        })
      ])
    }
  }
})

const route = useRoute();
const router = useRouter();

const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();
const lingoStore = useLingoStore();

const pages = [
  {
    name: 'Lingo Data',
    path: '/main/lingo-data'
  }
];

// --- state
const gradeFilter = ref<string>('')
const searchQuery = ref<string>('')
const sevenDaysAgo = new Date()
sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)
const fromDate = ref<Date>(sevenDaysAgo)
const toDate = ref<Date>(new Date())

const sortKey = ref<string>('displayName')
const sortDir = ref<'asc' | 'desc'>('asc')
const itemsPerPage = ref<number>(BATCH_SIZE)

// Status modal state
const statusModalOpen = ref(false)
const selectedStudentLastOnline = ref<Date | string | null>(null)

// Interventions modal state
const interventionsModalOpen = ref(false)
const selectedStudentForInterventions = ref<StudentDisplay | null>(null)

// Lingo data loading state
const lingoDataLoading = ref(false)

// True once the first full load (learner + lingo data) has completed
const initialLoadComplete = ref(false)

// --- Duration formatting (input: seconds)
function formatDuration(seconds: number): string {
  if (seconds === 0) return '-'
  if (seconds < 90) return '1 min'
  const minutes = Math.round(seconds / 60)
  if (minutes < 100) return `${minutes} min`
  const hours = Math.round(minutes / 60)
  return `${hours} hr`
}

function getInterventionKCs(lingoData: StudentLingoData | undefined): KnowledgeComponent[] {
  if (!lingoData) return []

  const activeKcs = [
    ...(lingoData.currentSpellingActivityKcs || []),
    ...(lingoData.currentVocabularyActivityKcs || []),
  ]

  return activeKcs.filter(kc => kc.status === 'learning')
}

// --- derived
const displayStudents = computed<StudentDisplay[]>(() => {
  const active = (learnerStore.schoolLearners || []).filter(l => l.status === 'active')
  return active.map(learner => {
    const mathClasses = learner.classes?.filter(c => c.subject.code === 'MATHS').map(c => c.name) || []
    const englishClasses = learner.classes?.filter(c => c.subject.code === 'ENGLISH').map(c => c.name) || []

    // Real lingo data
    const lingoData = lingoStore.getLingoDataByStudentId(learner._id)
    const workingOn = getWorkingOn(lingoData)
    const interventionKCs = getInterventionKCs(lingoData)
    const interventions = interventionKCs.length

    // Real classwork/homework from engagement data
    const engagementTime = lingoStore.getEngagementTimeByStudentId(learner._id)
    const classworkSeconds = engagementTime?.classworkSeconds ?? 0
    const homeworkSeconds = engagementTime?.homeworkSeconds ?? 0

    return {
      ...learner,
      displayName: `${learner.lastName}, ${learner.firstName}`,
      mathClasses,
      englishClasses,
      classwork: formatDuration(classworkSeconds),
      classworkSeconds,
      homework: formatDuration(homeworkSeconds),
      homeworkSeconds,
      workingOn,
      interventions,
      interventionKCs,
    }
  })
})

const gradesWithClasses = computed<number[]>(() => {
  const structure = schoolStore.currentSchoolStructure
  if (!structure) return []
  return [...new Set(structure.classGroups.filter(c => c.gradeLevel != null).map(c => c.gradeLevel))].sort((a, b) => a - b)
})

const subjectsPresent = computed(() => {
  const structure = schoolStore.currentSchoolStructure
  if (!structure || !structure.subjectsAvailable) {
    const set = new Set<string>()
    learnerStore.schoolLearners?.forEach(l => l.classes?.forEach(c => set.add(c.subject.code)))
    return { bothPresent: set.has('MATHS') && set.has('ENGLISH') }
  }
  const codes = structure.subjectsAvailable.map(s => s.code)
  return { bothPresent: codes.includes('MATHS') && codes.includes('ENGLISH') }
})

const classesByGrade = computed<Record<number, Array<{ value: string; label: string; sortKey: string }>>>(() => {
  const structure = schoolStore.currentSchoolStructure
  if (!structure) return {}
  const out: Record<number, Array<{ value: string; label: string; sortKey: string }>> = {}
  for (const grade of gradesWithClasses.value) {
    out[grade] = structure.classGroups
      .filter(c => c.gradeLevel === grade)
      .map(cls => {
        const subjectName = subjectStore.getSubjectNameById(cls.subject)
        const suffix = subjectsPresent.value.bothPresent ? `${subjectName}, ` : ''
        const label = `${cls.name} (${suffix}Grade ${grade})`
        return { value: cls.name, label, sortKey: label }
      })
      .sort((a, b) => a.sortKey.localeCompare(b.sortKey))
  }
  return out
})

const gradeFilterOptions = computed(() =>
  gradesWithClasses.value.map(grade => ({
    groupLabel: `Grade ${grade} (All)`,
    groupValue: `grade-${grade}`,
    items: (classesByGrade.value[grade] || []).map(cls => ({ label: cls.label, value: cls.value })),
  })),
)

// filtered + sorted
const filteredStudents = computed<StudentDisplay[]>(() => {
  let list = [...displayStudents.value]

  // Class/Grade filter
  if (gradeFilter.value) {
    if (gradeFilter.value.startsWith('grade-')) {
      const gradeLevel = parseInt(gradeFilter.value.replace('grade-', ''))
      list = list.filter(s => {
        const allClassNames = [...s.mathClasses, ...s.englishClasses]
        return allClassNames.some(name => {
          const grp = schoolStore.currentSchoolStructure?.classGroups.find(c => c.name === name)
          return grp?.gradeLevel === gradeLevel
        })
      })
    } else {
      list = list.filter(s => s.mathClasses.includes(gradeFilter.value) || s.englishClasses.includes(gradeFilter.value))
    }
  }

  // Search
  if (searchQuery.value.trim()) {
    const q = searchQuery.value.toLowerCase()
    list = list.filter(s =>
      (s.displayName || '').toLowerCase().includes(q) ||
      (s.email || '').toLowerCase().includes(q) ||
      (s.firstName || '').toLowerCase().includes(q) ||
      (s.lastName || '').toLowerCase().includes(q)
    )
  }

  // Sort
  const key = sortKey.value as keyof StudentDisplay
  const dir = sortDir.value === 'asc' ? 1 : -1

  list.sort((a, b) => {
    let va = a[key]
    let vb = b[key]

    // Handle lastOnline sorting (date comparison)
    if (key === 'lastOnline') {
      const da = va ? new Date(va as string).getTime() : 0
      const db = vb ? new Date(vb as string).getTime() : 0
      return (da - db) * dir
    }

    // Null handling
    if (va == null && vb == null) return 0
    if (va == null) return 1 * dir
    if (vb == null) return -1 * dir

    // Numeric comparison
    const na = Number(va)
    const nb = Number(vb)
    if (!isNaN(na) && !isNaN(nb)) {
      return (na - nb) * dir
    }

    // String comparison
    return String(va).localeCompare(String(vb)) * dir
  })

  return list
})

const paginatedStudents = computed(() => filteredStudents.value.slice(0, itemsPerPage.value))
const startIndex = computed(() => 0)
const endIndex = computed(() => Math.min(itemsPerPage.value, filteredStudents.value.length))
const hasMore = computed(() => filteredStudents.value.length > itemsPerPage.value)
const nextBatchSize = computed(() => Math.min(50, filteredStudents.value.length - itemsPerPage.value))

// --- actions
function toggleSort(key: string) {
  if (sortKey.value === key) {
    sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortDir.value = 'asc'
  }
}

const showMore = () => { itemsPerPage.value += BATCH_SIZE }

const goToStudentData = (student: Learner) => {
  router.push({ name: 'lingo-student-data', params: { studentId: String(student._id) } })
}

function openStatusModal(student: StudentDisplay) {
  selectedStudentLastOnline.value = student.lastOnline ?? null
  statusModalOpen.value = true
}

function openInterventionsModal(student: StudentDisplay) {
  selectedStudentForInterventions.value = student
  interventionsModalOpen.value = true
}

// --- Data refresh (pauses when tab is hidden)
let refreshIntervalId: ReturnType<typeof setInterval> | null = null;
let engagementIntervalId: ReturnType<typeof setInterval> | null = null;
const isRefreshing = ref(false);

const refreshStudentData = async () => {
  const schoolId = schoolStore.currentSchoolStructure?._id;
  if (!schoolId || isRefreshing.value) return;

  isRefreshing.value = true;
  try {
    await learnerStore.fetchSchoolLearners(schoolId);
  } catch (error) {
    console.error("Failed to refresh data:", error);
  } finally {
    isRefreshing.value = false;
  }
};

const shouldRefreshData = () => {
  const lastFetch = learnerStore.lastFetchTimestamp;
  if (!lastFetch) return true; // Never fetched
  return Date.now() - lastFetch > REFRESH_INTERVAL_MS;
};

const startPolling = () => {
  if (!refreshIntervalId) {
    refreshIntervalId = setInterval(refreshStudentData, REFRESH_INTERVAL_MS);
  }
  if (!engagementIntervalId) {
    engagementIntervalId = setInterval(fetchEngagementData, ENGAGEMENT_REFRESH_INTERVAL_MS);
  }
};

const stopPolling = () => {
  if (refreshIntervalId) {
    clearInterval(refreshIntervalId);
    refreshIntervalId = null;
  }
  if (engagementIntervalId) {
    clearInterval(engagementIntervalId);
    engagementIntervalId = null;
  }
};

const handleVisibilityChange = () => {
  if (document.hidden) {
    stopPolling();
  } else {
    // Refresh immediately when tab becomes visible again, then resume polling
    refreshStudentData();
    fetchEngagementData();
    startPolling();
  }
};

// --- Engagement data fetch (classwork/homework)
const engagementLoading = ref(false)

async function fetchEngagementData() {
  const activeIds = (learnerStore.schoolLearners || [])
    .filter(l => l.status === 'active')
    .map(l => l._id)
  if (activeIds.length === 0 || !schoolStore.currentSchool?._id) return

  engagementLoading.value = true
  try {
    await lingoStore.fetchLingoEngagementTime({
      school: schoolStore.currentSchool._id,
      studentIds: activeIds,
      startDate: moment(fromDate.value).format('YYYY-MM-DD'),
      endDate: moment(toDate.value).format('YYYY-MM-DD'),
      timezone: schoolStore.currentSchool?.timezone ?? 'Africa/Johannesburg',
    })
  } catch (error) {
    console.error("Failed to fetch engagement data:", error)
  } finally {
    engagementLoading.value = false
  }
}

// Re-fetch engagement data when date range changes
watch([fromDate, toDate], () => {
  fetchEngagementData()
})

// If a classId is provided as a query param, preselect it (mirrors Manage Students)
onMounted(async () => {
  // Check if data needs refresh (30 seconds expired)
  if (shouldRefreshData()) {
    await refreshStudentData();
  }

  document.addEventListener('visibilitychange', handleVisibilityChange);

  const classId = route.query.classId as string | undefined
  if (classId) {
    const cls = schoolStore.currentSchoolStructure?.classGroups.find(c => c._id === classId)
    if (cls) gradeFilter.value = cls.name
  }

  // Fetch lingo progress data for all active students
  const activeIds = (learnerStore.schoolLearners || [])
    .filter(l => l.status === 'active')
    .map(l => l._id)
  if (activeIds.length > 0) {
    lingoDataLoading.value = true
    try {
      await lingoStore.fetchStudentLingoData({ studentIds: activeIds })
    } catch (error) {
      console.error("Failed to fetch lingo data:", error)
    } finally {
      lingoDataLoading.value = false
    }
  }

  // Reveal the table — learner + lingo data are ready
  initialLoadComplete.value = true

  // Start background polling now that initial load is done
  startPolling();

  // Engagement data (classwork/homework) can populate after the table is shown
  fetchEngagementData()
});

onUnmounted(() => {
  stopPolling();
  document.removeEventListener('visibilitychange', handleVisibilityChange);
});

// --- Export Logic
const loadingExport = ref(false);

/**
 * Iterates over the first row of a worksheet and applies a bold font style.
 * @param worksheet The worksheet to modify.
 * @param data The array of objects used to generate the sheet, to get header keys.
 */
const addBoldHeaders = (worksheet: XLSX.WorkSheet, data: Array<Array<string | number>>) => {
  if (!data || data.length === 0) return;

  const headers = data[0];
  headers.forEach((_, index: number) => {
    const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
    if (worksheet[cellAddress]) {
      worksheet[cellAddress].s = { font: { bold: true } };
    }
  });
};

function getLevelStats(kcs: KnowledgeComponent[]) {
  let currentLevel = 'Level 1';
  let totalGaps = 0;

  const calcLevelPerf = (lvl: number) => {
    const kcsInLevel = kcs.filter(kc => kc.level === lvl);
    const gapsFilled = kcsInLevel.filter(kc => ['mastered_prior_learning', 'mastered_new_learning'].includes(kc.status));
    totalGaps += gapsFilled.length;

    if (kcsInLevel.length === 0) return 'Emerging';

    const masteryRate = gapsFilled.length / kcsInLevel.length;
    if (masteryRate > 0.9) return 'Exceptional';
    if (masteryRate > 0.7) return 'Strong';
    if (masteryRate > 0.5) return 'Capable';
    if (masteryRate > 0.2) return 'Developing';
    return 'Emerging';
  };

  for (let i = 1; i <= 8; i++) {
    const label = calcLevelPerf(i);
    if (label !== 'Exceptional') {
      currentLevel = i === 8 ? 'Level 7+' : `Level ${i}`;
      break;
    }
    if (i === 8 && label === 'Exceptional') {
      currentLevel = 'Level 7+';
    }
  }
  return { currentLevel, totalGaps };
}

async function exportLingoData() {
  if (loadingExport.value) return;
  loadingExport.value = true;

  try {
    const studentsToExport = filteredStudents.value;
    if (studentsToExport.length === 0) {
      showToast({ text: "No students to export.", type: 'error', icon: ExclamationCircleIcon });
      return;
    }

    const studentIds = studentsToExport.map(s => s._id);
    await lingoStore.fetchStudentLingoData({ studentIds });

    let hasIncomplete = false;

    const rows = studentsToExport.map(student => {
      const lingoData = lingoStore.getLingoDataByStudentId(student._id);
      const allKCs = lingoData?.allKCs || [];

      // Spelling
      const spellingKCs = allKCs.filter(kc => kc.type === 'spelling');
      const spellingStats = getLevelStats(spellingKCs);
      const isSpellingDiagnosticComplete = lingoData?.spellingDiagnosticComplete !== false;
      const spellingLevelExport = isSpellingDiagnosticComplete ? spellingStats.currentLevel : `${spellingStats.currentLevel}*`;

      // Vocabulary
      const vocabKCs = allKCs.filter(kc => kc.type === 'vocabulary');
      const vocabStats = getLevelStats(vocabKCs);
      const isVocabDiagnosticComplete = lingoData?.vocabularyDiagnosticComplete !== false;
      const vocabLevelExport = isVocabDiagnosticComplete ? vocabStats.currentLevel : `${vocabStats.currentLevel}*`;

      const totalGaps = spellingStats.totalGaps + vocabStats.totalGaps;

      if (!isSpellingDiagnosticComplete || !isVocabDiagnosticComplete) {
        hasIncomplete = true;
      }

      // English Class Name
      const englishClass = student.englishClasses[0] || "";

      // English Class Grade
      let englishGrade = student.grade?.toString() || "";
      if (englishClass) {
        const grp = schoolStore.currentSchoolStructure?.classGroups.find(c => c.name === englishClass);
        if (grp?.gradeLevel) englishGrade = grp.gradeLevel.toString();
      }

      return [
        student.firstName,
        student.lastName,
        student.studentNumber || "",
        englishClass,
        englishGrade,
        spellingLevelExport,
        spellingStats.totalGaps,
        vocabLevelExport,
        vocabStats.totalGaps,
        totalGaps
      ];
    });

    const headers = [
      "First Name",
      "Surname",
      "Student Number",
      "English Class",
      "English Class Grade",
      "Spelling Level",
      "Spelling Gaps Filled",
      "Vocabulary Level",
      "Vocabulary Gaps Filled",
      "Total Gaps Filled"
    ];

    // Sort by Surname then First Name
    rows.sort((a, b) => {
      const surnameComp = String(a[1]).localeCompare(String(b[1]));
      if (surnameComp !== 0) return surnameComp;
      return String(a[0]).localeCompare(String(b[0]));
    });

    const finalData = [headers, ...rows];

    if (hasIncomplete) {
      finalData.push([]);
      finalData.push(["*Early-stage level estimate. Full placement occurs after a small number of diagnostic lists."]);
    }

    const worksheet = XLSX.utils.aoa_to_sheet(finalData);

    addBoldHeaders(worksheet, finalData);

    // Column Widths
    worksheet['!cols'] = headers.map(() => ({ wch: 20 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    const timestamp = new Date().toISOString().slice(0, 10);
    const filename = `Class_Levels_Gaps_${timestamp}.xlsx`;

    XLSX.writeFile(workbook, filename);

    showToast({ text: "Export complete.", type: 'success', icon: CheckCircleIcon });

  } catch (error) {
    console.error("Export failed", error);
    showToast({ text: "Export failed. Please try again.", type: 'error', icon: ExclamationCircleIcon });
  } finally {
    loadingExport.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_title, { pages: pages }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center gap-2 rounded-lg border border-gray-300 px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50",
        onClick: exportLingoData,
        disabled: loadingExport.value
      }, [
        (loadingExport.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_spinner_loader, {
                color: 'text-gray-600',
                class: "h-5 w-5"
              })
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-export',
                title: 'rl export',
                "aria-hidden": "true"
              })
            ])),
        _createTextVNode(" Export ")
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: { name: 'lingo-data' },
          class: _normalizeClass(["whitespace-nowrap border-b-2 py-2 px-1 text-sm font-semibold", _unref(route).name === 'lingo-data'
          ? 'border-indigo-600 text-indigo-600'
          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Overview ")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: { name: 'lingo-levels-gaps-filled' },
          class: _normalizeClass(["whitespace-nowrap border-b-2 py-2 px-1 text-sm font-semibold", _unref(route).name === 'lingo-levels-gaps-filled'
          ? 'border-indigo-600 text-indigo-600'
          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Levels and Gaps Filled ")
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_unref(DatePicker), {
        modelValue: fromDate.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fromDate).value = $event)),
        masks: { input: 'DD/MM/YYYY' }
      }, {
        default: _withCtx(({ inputValue, inputEvents }) => [
          _createElementVNode("input", _mergeProps({
            type: "text",
            value: inputValue
          }, _toHandlers(inputEvents, true), {
            class: "rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500",
            placeholder: "Start Date",
            readonly: ""
          }), null, 16, _hoisted_10)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_11,
      _createVNode(_unref(DatePicker), {
        modelValue: toDate.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((toDate).value = $event)),
        masks: { input: 'DD/MM/YYYY' }
      }, {
        default: _withCtx(({ inputValue, inputEvents }) => [
          _createElementVNode("input", _mergeProps({
            type: "text",
            value: inputValue
          }, _toHandlers(inputEvents, true), {
            class: "rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500",
            placeholder: "End Date",
            readonly: ""
          }), null, 16, _hoisted_12)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_FormKit, {
          type: "treeSelect",
          name: "gradeFilter",
          modelValue: gradeFilter.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((gradeFilter).value = $event)),
          selectOptions: gradeFilterOptions.value,
          classes: { outer: 'w-full' }
        }, null, 8, ["modelValue", "selectOptions"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_FormKit, {
          type: "text",
          name: "search",
          placeholder: 'Search',
          modelValue: searchQuery.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
          classes: { input: 'pl-10' },
          "prefix-icon": "search"
        }, null, 8, ["modelValue"])
      ])
    ]),
    (!initialLoadComplete.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_spinner_loader, { color: 'text-indigo-600' }),
            _hoisted_19
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("table", _hoisted_22, [
              _createElementVNode("thead", _hoisted_23, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: "lingo-th lingo-th--sortable",
                    style: {"width":"80px"},
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSort('lastOnline')))
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_unref(SortIcon), {
                        active: sortKey.value === 'lastOnline',
                        dir: sortDir.value
                      }, null, 8, ["active", "dir"])
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "lingo-th lingo-th--sortable",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSort('displayName')))
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createVNode(_unref(QuestionMarkCircleIcon), { class: "h-4 w-4 text-gray-400" })
                      ])), [
                        [
                          _directive_tooltip,
                          'Learner Name',
                          "right",
                          { tooltip: true }
                        ]
                      ]),
                      _createVNode(_unref(SortIcon), {
                        active: sortKey.value === 'displayName',
                        dir: sortDir.value
                      }, null, 8, ["active", "dir"])
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "lingo-th lingo-th--sortable",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSort('classworkSeconds')))
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createVNode(_unref(QuestionMarkCircleIcon), { class: "h-4 w-4 text-gray-400" })
                      ])), [
                        [
                          _directive_tooltip,
                          'Time spent on learning activities only, during school hours Monday to Friday. This data is refreshed every 15 minutes.',
                          "right",
                          { tooltip: true }
                        ]
                      ]),
                      _createVNode(_unref(SortIcon), {
                        active: sortKey.value === 'classworkSeconds',
                        dir: sortDir.value
                      }, null, 8, ["active", "dir"])
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "lingo-th lingo-th--sortable",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSort('homeworkSeconds')))
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createVNode(_unref(QuestionMarkCircleIcon), { class: "h-4 w-4 text-gray-400" })
                      ])), [
                        [
                          _directive_tooltip,
                          'Time spent on learning activities only, outside of school hours Monday to Friday. This data is refreshed every 15 minutes.',
                          "right",
                          { tooltip: true }
                        ]
                      ]),
                      _createVNode(_unref(SortIcon), {
                        active: sortKey.value === 'homeworkSeconds',
                        dir: sortDir.value
                      }, null, 8, ["active", "dir"])
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "lingo-th",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSort('workingOn')))
                  }, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode(_unref(SortIcon), {
                        active: sortKey.value === 'workingOn',
                        dir: sortDir.value
                      }, null, 8, ["active", "dir"])
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "lingo-th lingo-th--sortable",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleSort('interventions')))
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createVNode(_unref(QuestionMarkCircleIcon), { class: "h-4 w-4 text-gray-400" })
                      ])), [
                        [
                          _directive_tooltip,
                          'Number of interventions',
                          "right",
                          { tooltip: true }
                        ]
                      ]),
                      _createVNode(_unref(SortIcon), {
                        active: sortKey.value === 'interventions',
                        dir: sortDir.value
                      }, null, 8, ["active", "dir"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedStudents.value, (student) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: student._id,
                    class: "hover:bg-gray-50"
                  }, [
                    _createElementVNode("td", _hoisted_37, [
                      _createVNode(StatusBadge, {
                        lastOnline: student.lastOnline,
                        onClick: ($event: any) => (openStatusModal(student))
                      }, null, 8, ["lastOnline", "onClick"])
                    ]),
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-sm font-medium text-indigo-600 hover:text-indigo-500 truncate",
                        onClick: ($event: any) => (goToStudentData(student))
                      }, _toDisplayString(student.displayName), 9, _hoisted_39)
                    ]),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(student.classwork), 1),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(student.homework), 1),
                    _createElementVNode("td", _hoisted_42, _toDisplayString(student.workingOn), 1),
                    _createElementVNode("td", _hoisted_43, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (openInterventionsModal(student)),
                        class: "cursor-pointer"
                      }, [
                        _createVNode(LingoBadge, {
                          label: String(student.interventions),
                          size: "sm",
                          variant: "pill",
                          color: student.interventions === 0 ? 'success' : 'purple'
                        }, null, 8, ["label", "color"])
                      ], 8, _hoisted_44)
                    ])
                  ]))
                }), 128)),
                (paginatedStudents.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                      _createElementVNode("td", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_unref(UserIcon), { class: "h-10 w-10 mx-auto text-gray-400" })
                        ]),
                        _hoisted_48,
                        _createElementVNode("div", null, "Try changing the Class(es) / Grade(s) filter" + _toDisplayString(searchQuery.value ? ' or your search.' : '.'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])),
    (initialLoadComplete.value && filteredStudents.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("div", null, " Showing " + _toDisplayString(startIndex.value + 1) + "-" + _toDisplayString(endIndex.value) + " of " + _toDisplayString(filteredStudents.value.length) + " students ", 1),
          (hasMore.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "text-indigo-600 hover:text-indigo-500",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (showMore()))
              }, " Show " + _toDisplayString(nextBatchSize.value) + " More ", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusDetailModal, {
      isOpen: statusModalOpen.value,
      lastOnline: selectedStudentLastOnline.value,
      onClose: _cache[11] || (_cache[11] = ($event: any) => (statusModalOpen.value = false))
    }, null, 8, ["isOpen", "lastOnline"]),
    _createVNode(InterventionsModal, {
      isOpen: interventionsModalOpen.value,
      studentName: selectedStudentForInterventions.value?.displayName ?? '',
      studentId: selectedStudentForInterventions.value?._id ?? '',
      interventionKCs: selectedStudentForInterventions.value?.interventionKCs ?? [],
      onClose: _cache[12] || (_cache[12] = ($event: any) => (interventionsModalOpen.value = false))
    }, null, 8, ["isOpen", "studentName", "studentId", "interventionKCs"])
  ], 64))
}
}

})